import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type DocumentFieldCorrectionFailedAction = {
	type: 'DOCUMENT_FIELD_CORRECTION_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): DocumentFieldCorrectionFailedAction => ({
	type: 'DOCUMENT_FIELD_CORRECTION_FAILED',
	payload,
});
